import React from 'react'
import FundsIcon from 'assets/images/funds/moneypool-2.png'
import FundsIcon2 from 'assets/images/funds/moneyPool-1.svg'
import { MoneyPoolsStatus } from 'utilities/helper/moneyPools'
import { useNavigate } from 'react-router-dom'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'

interface IItem {
    item: MoneyPool
}

export default function Item({ item }: IItem) {
    const navigate = useNavigate()

    const showLoanStatus =
        item.poolship.active_installments_status !== 'no-loan' &&
        item.poolship.active_installments_status !== 'fully-repaid'

    return (
        <div
            className="bg-white rounded-[10px] shadow-card my-[6px] cursor-pointer px-4 py-2.5"
            onClick={() =>
                navigate(`/fund/${item.id}`, {
                    state: { poolShipId: item.poolship.id },
                })
            }
        >
            {/* Header: avatar (end) + name/member (start) */}
            <div className="flex items-start gap-2">
                <div className="flex-1 min-w-0">
                    <p className="text-base font-bold text-black text-right truncate">
                        صندوق {item.name}
                    </p>
                    <p className="text-sm font-normal text-text-body text-right mt-1">
                        {item.active_members_count} عضو، پس‌انداز
                    </p>
                </div>
                <img
                    src={
                        item.custom_avatar
                            ? item.custom_avatar
                            : item.image_id === 2
                            ? FundsIcon
                            : FundsIcon2
                    }
                    alt="fund-icon"
                    className="w-[60px] h-[60px] rounded-full border border-[#DCE0E5] object-cover p-[1px] shrink-0"
                />
            </div>

            {/* divider */}
            <div className="h-px bg-[#DCE0E5] mt-2.5" />

            {/* value rows — label (right) then value (left) for RTL */}
            <div>
                {item.show_box_balance && (
                    <div className="flex justify-between items-baseline mt-2.5">
                        <p className="text-sm font-normal text-text-secondary">
                            موجودی صندوق
                        </p>
                        <p className="text-sm font-normal text-black text-left">
                            {Number(
                                Number(item.hamyan_balance) +
                                    Number(item.bank_balance)
                            ).toLocaleString()}{' '}
                            تومان
                        </p>
                    </div>
                )}
                <div className="flex justify-between items-baseline mt-2.5">
                    <p className="text-sm font-normal text-text-secondary">
                        حق عضویت
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {Number(item.share_value_amount).toLocaleString()} تومان
                    </p>
                </div>
                <div className="flex justify-between items-baseline mt-1">
                    <p className="text-sm font-normal text-text-secondary">
                        تاریخ سررسید
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {ConvertJalaliDate(item.jalali_due_date)}
                    </p>
                </div>
            </div>

            {/* divider */}
            <div className="h-px bg-[#DCE0E5] mt-2.5" />

            {/* payment status */}
            <p className="text-sm font-normal text-text-secondary text-right mt-2.5">
                وضعیت پرداخت دوره
            </p>

            {/* portion status row: label+dot (right) + chip (left) for RTL */}
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center gap-1.5">
                    <span className="w-1 h-1 rounded-full bg-text-secondary" />
                    <p className="text-sm font-normal text-text-secondary">
                        حق عضویت
                    </p>
                </div>
                <div
                    className="inline-flex items-center gap-1 rounded-[10px] pl-2.5 pr-2.5 pt-0.5 pb-1"
                    style={{
                        backgroundColor:
                            MoneyPoolsStatus[
                                item.poolship.portion_payment_status
                            ].bgColor,
                    }}
                >
                    <img
                        className="w-4 h-4"
                        src={
                            MoneyPoolsStatus[
                                item.poolship.portion_payment_status
                            ].icon
                        }
                        alt="moneypools-status"
                    />
                    <p
                        className="text-xs font-bold"
                        style={{
                            color: MoneyPoolsStatus[
                                item.poolship.portion_payment_status
                            ].color,
                        }}
                    >
                        {
                            MoneyPoolsStatus[
                                item.poolship.portion_payment_status
                            ].title
                        }
                    </p>
                </div>
            </div>

            {/* loan status row: label+dot (right) + chip (left) for RTL */}
            {showLoanStatus && (
                <div className="flex justify-between items-center mt-3">
                    <div className="flex items-center gap-1.5">
                        <span className="w-1 h-1 rounded-full bg-text-secondary" />
                        <p className="text-sm font-normal text-text-secondary">
                            وام
                        </p>
                    </div>
                    <div
                        className="inline-flex items-center gap-1 rounded-[10px] pl-2.5 pr-2.5 pt-0.5 pb-1"
                        style={{
                            backgroundColor:
                                MoneyPoolsStatus[
                                    item.poolship.active_installments_status
                                ].bgColor,
                        }}
                    >
                        <img
                            className="w-4 h-4"
                            src={
                                MoneyPoolsStatus[
                                    item.poolship.active_installments_status
                                ].icon
                            }
                            alt="moneypools-status"
                        />
                        <p
                            className="text-xs font-bold"
                            style={{
                                color: MoneyPoolsStatus[
                                    item.poolship.active_installments_status
                                ].color,
                            }}
                        >
                            {
                                MoneyPoolsStatus[
                                    item.poolship.active_installments_status
                                ].title
                            }
                        </p>
                    </div>
                </div>
            )}
        </div>
    )
}
